export default "__VITE_ASSET__CCMikFpr__"